import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { registerUser } from "../../services/authService";
import mylogo from "../../myimgs/nivora 1.png";
import email from "../../myimgs/email.png";
import pwd from "../../myimgs/pwd.png";
import name from "../../myimgs/name.png";
import phone from "../../myimgs/phone.png";
import "./signup.css";
import Header from "../../components/Navbar";
import Lofinimg from "../../myimgs/mobile style.png";
import play from "../../myimgs/Play app 1.png";
import app from "../../myimgs/Play app 2.png";

const Signup = () => {
  const navigate = useNavigate();

  // ✅ Form state
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // ✅ Input change handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Verify Email Function (with 6-box OTP UI)
  const handleVerifyEmail = async () => {
    if (!formData.email) {
      Swal.fire("Error", "Please enter your email first!", "error");
      return;
    }

    try {
      setVerifying(true);

      const baseURL = process.env.REACT_APP_API_BASE_URL;
      // send request to send OTP
      const response = await axios.post(
        `${baseURL}/auth/request?email=${encodeURIComponent(formData.email)}`
      );

      if (response.status === 200) {
        // show custom HTML modal with 6 input boxes
        await Swal.fire({
          title: "Email Verification",
          html: `
            <p>A verification code has been sent to <strong>${formData.email}</strong></p>
            <div id="otp-boxes" style="display:flex;gap:8px;justify-content:center;margin-top:12px;">
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
              <input class="swal2-otp" maxlength="1" inputmode="numeric" pattern="[0-9]*" />
            </div>
            <div id="otp-error" style="color:#d33;margin-top:10px;display:none;text-align:center;font-size:13px;"></div>
          `,
          showCancelButton: false,
          confirmButtonText: "Verify OTP",
          focusConfirm: false, // we'll manage focus
          allowOutsideClick: false,
          didOpen: () => {
            const inputs =
              Swal.getHtmlContainer().querySelectorAll(".swal2-otp");
            // focus first input
            if (inputs && inputs.length) inputs[0].focus();

            // helper to join values
            const getOtp = () =>
              Array.from(inputs)
                .map((i) => i.value.trim())
                .join("");

            // handle input events
            inputs.forEach((input, idx) => {
              input.addEventListener("input", (e) => {
                const val = e.target.value;
                // allow only digits
                if (/[^0-9]/.test(val)) {
                  e.target.value = val.replace(/[^0-9]/g, "");
                  return;
                }
                if (val.length === 1 && idx < inputs.length - 1) {
                  inputs[idx + 1].focus();
                }
              });

              input.addEventListener("keydown", (e) => {
                if (e.key === "Backspace" && !e.target.value && idx > 0) {
                  inputs[idx - 1].focus();
                }
                if (e.key === "ArrowLeft" && idx > 0) {
                  inputs[idx - 1].focus();
                }
                if (e.key === "ArrowRight" && idx < inputs.length - 1) {
                  inputs[idx + 1].focus();
                }
              });

              // support paste (paste whole OTP)
              input.addEventListener("paste", (e) => {
                e.preventDefault();
                const paste = (e.clipboardData || window.clipboardData).getData(
                  "text"
                );
                const digits = paste
                  .replace(/\D/g, "")
                  .slice(0, inputs.length)
                  .split("");
                digits.forEach((d, i) => {
                  inputs[i].value = d;
                });
                const nextIndex = Math.min(digits.length, inputs.length - 1);
                inputs[nextIndex].focus();
              });
            });
          },
          preConfirm: async () => {
            const inputs =
              Swal.getHtmlContainer().querySelectorAll(".swal2-otp");
            const otp = Array.from(inputs)
              .map((i) => i.value.trim())
              .join("");

            if (otp.length !== 6) {
              // show inline error
              const errEl = Swal.getHtmlContainer().querySelector("#otp-error");
              if (errEl) {
                errEl.style.display = "block";
                errEl.textContent = "Please enter 6-digit OTP.";
              }
              // prevent modal from closing
              return Swal.showValidationMessage("Please enter 6-digit OTP.");
            }

            // call verify-otp API
            try {
              const verifyRes = await axios.post(
                `${baseURL}/auth/verify-otp?email=${encodeURIComponent(
                  formData.email
                )}&otp=${encodeURIComponent(otp)}`
              );

              if (verifyRes.status === 200) {
                return { success: true, data: verifyRes.data };
              } else {
                return Swal.showValidationMessage(
                  "Invalid OTP. Please try again!"
                );
              }
            } catch (err) {
              const msg =
                err.response?.data?.message || "OTP verification failed!";
              return Swal.showValidationMessage(msg);
            }
          },
        }).then((result) => {
          if (result.isConfirmed && result.value && result.value.success) {
            setIsEmailVerified(true);
            Swal.fire("Success", "Email verified successfully!", "success");
          }
        });
      } else {
        Swal.fire("Error", "Failed to send verification email!", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Failed to send verification email!",
        "error"
      );
    } finally {
      setVerifying(false);
    }
  };

  // ✅ Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
      };

      const res = await registerUser(payload);
      Swal.fire("Success", "Signup successful!", "success");
      console.log("Response:", res.data);

      navigate("/login");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Signup failed!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="login-container scrolleffect">
        <div className="login-left">
          <img src={Lofinimg} alt="" />
          <div className="overlay-text">
            <h2>Get Twoffers App</h2>
            <p>
              Your next deal is always in reach. With the Twoffers app, you can
              browse, offer, and close on the go.
            </p>
          </div>
          <div className="flxname lofixname">
            <Link to="https://play.google.com/store/apps/details?id=com.twoffers">
              <img src={play} alt="" />
            </Link>
            <Link to="https://apps.apple.com/ae/app/twoffers/id6751880823">
              <img src={app} alt="" />
            </Link>
          </div>
        </div>

        <div className="login-right">
          <div className="login-box lopt">
            <div className="logo mb-3">
              <Link to="/">
                <img src={mylogo} alt="Logo" style={{ height: "50px" }} />
              </Link>
            </div>

            <h5 className="fw-bold">Welcome to Twoffers!</h5>
            <p className="text-muted small">
              Create a free account to favorite properties, place offer, and get
              real-time updates.
              <br />
              Already a member?{" "}
              <Link to="/login" className="link-primary">
                Sign in.
              </Link>
            </p>

            <form onSubmit={handleSubmit} className="kkkklllkkll">
              <div className="d-flex gap-3">
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <img src={name} alt="first name" />
                  </span>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="First Name"
                    required
                  />
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <img src={name} alt="last name" />
                  </span>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>

              {/* Email Address with Verify Button */}
              <div className="input-group mb-3 email-verify-group">
                <span className="input-group-text">
                  <img src={email} alt="email" />
                </span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Email Address"
                  required
                  readOnly={isEmailVerified}
                />
                {formData.email && (
                  <button
                    type="button"
                    className={`verify-btn ${
                      isEmailVerified ? "verified" : ""
                    }`}
                    onClick={handleVerifyEmail}
                    disabled={verifying || isEmailVerified}
                  >
                    {isEmailVerified
                      ? "Verified"
                      : verifying
                      ? "Sending..."
                      : "Verify Email"}
                  </button>
                )}
              </div>

              <div className="input-group mb-3">
                <span className="input-group-text">
                  <img src={phone} alt="phone" />
                </span>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Phone Number"
                  required
                />
              </div>

              <div className="input-group mb-3 custom-input-group">
                <span className="input-group-text left-icon">
                  <img src={pwd} alt="password" />
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-control custom-input"
                  placeholder="Password"
                  required
                />

                <span
                  className="input-group-text right-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁"}
                </span>
              </div>

              <div className="input-group mb-3 custom-input-group">
                <span className="input-group-text left-icon">
                  <img src={pwd} alt="confirm password" />
                </span>

                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="form-control custom-input"
                  placeholder="Confirm Password"
                  required
                />

                <span
                  className="input-group-text right-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? "🙈" : "👁"}
                </span>
              </div>

              <button
                type="submit"
                className="btn btn-dark w-100 mb-3"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Account"}
              </button>
            </form>

            <p className="text-muted small text-center mt-3">
              Continue with Google or Apple means you agree to Twoffers{" "}
              <Link to="/termsandconditions" className="link-primary">
                Terms
              </Link>{" "}
              and{" "}
              <Link to="/privacypolicy" className="link-primary">
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
